import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';

import { ENTRA_AUTH_CONFIG } from './entra-auth.config';
import { EntraAuthService } from './entra-auth.service';

export const entraAuthGuard: CanActivateFn = async () => {
  const config = inject(ENTRA_AUTH_CONFIG);
  const authService = inject(EntraAuthService);

  if (!config.enabled) {
    return true;
  }

  await authService.initialize();

  if (authService.isAuthenticated()) {
    return true;
  }

  await authService.signIn();
  return false;
};

